<div class="button-container">
  @for (navItem of headerNavItems(); track navItem.id) {
    <input
      type="hidden"
      [routerLink]="navItem.route"
      routerLinkActive
      [routerLinkActiveOptions]="{ exact: hasChildren }"
      #navRoute="routerLinkActive"
      [id]="navItem.id + '__is-route-active'" />

    @let isActive = navRoute.isActive;

    @if (navItem.id === 'communications_workflows') {
      <topo-action-menu
        style="margin-left: -0.25rem"
        location="left"
        theme="white">
        <topo-action
          [label]="navItem.label | translate"
          [icon]="navItem.iconPath"
          (actionClick)="navigate(navItem.route)" />
      </topo-action-menu>
    } @else {
      <topo-header-bar-tab-button
        theme="white"
        [isSelected]="isActive"
        [isSmall]="true"
        [label]="navItem.label | translate"
        (click)="navigate(navItem.route)"
        [icon]="navItem.iconPath" />
    }
  }
</div>
